<template>
  <q-layout view="lHh Lpr lFf">
    <q-page-container>
      <q-page class="flex flex-center bg-gradient">
        <div class="forgot-container">
          <!-- Logo e Título -->
          <div class="text-center q-mb-xl">
            <q-icon size="110px">
              <img src="../../assets/icon2.png" alt="">
            </q-icon>
            <h4 class="text-h4 text-weight-bold q-mb-sm q-mt-none">Recuperar Senha</h4>
            <p class="text-grey-7">Insira seu email para receber o link de recuperação</p>
          </div>

          <!-- Card de Recuperação -->
          <q-card class="forgot-card q-pa-lg shadow-10">
            <q-card-section>
              <q-form @submit="handleSendCode" class="q-gutter-md">
                <q-input
                  v-model="form.email"
                  type="email"
                  label="Email"
                  outlined
                  :rules="[
                    val => !!val || 'Email é obrigatório',
                    val => /.+@.+\..+/.test(val) || 'Email inválido'
                  ]"
                  lazy-rules
                  :error="!!errors.email"
                  :error-message="errors.email"
                >
                  <template v-slot:prepend>
                    <q-icon name="mail" />
                  </template>
                </q-input>

                <q-btn
                  type="submit"
                  color="primary"
                  label="Enviar Link de Recuperação"
                  :loading="loading"
                  unelevated
                  size="md"
                  class="full-width q-mt-md"
                  icon-right="send"
                />
              </q-form>
            </q-card-section>

            <!-- Divider -->
            <q-separator class="q-my-md" />

            <!-- Voltar ao Login -->
            <q-card-section class="text-center">
              <p class="text-grey-7 q-mb-none">
                Lembrou sua senha?
                <q-btn
                  flat
                  dense
                  color="primary"
                  label="Voltar ao Login"
                  @click="handleBackToLogin"
                  class="text-weight-bold"
                />
              </p>
            </q-card-section>
          </q-card>

          <!-- Footer -->
          <div class="text-center q-mt-md">
            <p class="text-grey-6 text-caption">
              © {{ new Date().getFullYear() }} Plataforma Imobiliária. Um produto da <a href="https://marrar.co.mz" target="__blank" style="text-decoration: none;">Marrar, LDA</a>.
            </p>
          </div>
        </div>
      </q-page>
    </q-page-container>
  </q-layout>
</template>

<script setup>
import { ref } from 'vue'
import router from '@/router'
import store from '@/vuex/store'
import Swal from 'sweetalert2'


const form = ref({
  email: ''
})

const errors = ref({
  email: ''
})


const loading = ref(false)

const handleSendCode = async () => {
  loading.value = true
  errors.value = { email: '' }

  try {
    // Substitua com sua chamada de API
    await store.dispatch('auth/forgotPassword', {
      email: form.value.email
    })

    Swal.fire({
      icon: 'success',
      title: 'Email Enviado',
      text: 'Verifique seu email para o link de recuperação de senha.',
      confirmButtonText: 'OK'
    }).then(() => {
      router.push('/login')
    })
  } catch (error) {
    console.error('Erro ao enviar email:', error)
    Swal.fire({
      icon: 'error',
      title: 'Erro',
      text: 'Não foi possível enviar o email. Verifique o endereço e tente novamente.'
    })
  } finally {
    loading.value = false
  }
}

const handleBackToLogin = () => {
  router.push('/login')
}
</script>

<style scoped>
.bg-gradient {
  background: linear-gradient(135deg, #e3f2fd 0%, #ffffff 50%, #e8eaf6 100%);
  min-height: 100vh;
}

.forgot-container {
  width: 100%;
  max-width: 450px;
  padding: 20px;
}

.forgot-card {
  border-radius: 16px;
  border: 1px solid #e0e0e0;
}

.shadow-10 {
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
}

@media (max-width: 600px) {
  .forgot-container {
    max-width: 100%;
  }
}
</style>